/**
 * TtfAppleCmapSubTable.ts class for EJ2-PDF
 */
var TtfAppleCmapSubTable = /** @class */ (function () {
    function TtfAppleCmapSubTable() {
    }
    return TtfAppleCmapSubTable;
}());
export { TtfAppleCmapSubTable };
